/*projectGallery.js*/
import * as constants from './../constants';
import { isDescendant } from "../helpers/isDescendant"

//import scroll-lock package dependancy
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { setFillGapMethod, addFillGapTarget, addFillGapSelector } from 'scroll-lock';
//import overlayscrollbars dependancy
import OverlayScrollbars from 'overlayscrollbars';
/* import Flickity*/
import Flickity from 'flickity';

// vars
let sliderContainer, sliderContainerWrap
let gallery, galleryImageLinks
let slider
let isFlickity
let initialIndex
// let isDragging;


const setSlider = (clickedElementId) => {

  let galleryImages = document.querySelectorAll('[data-flickity-target-id]');
  let navcontainer = document.querySelector('[gallery-slider-nav-count]');
  let navWrapper = document.querySelector('[gallery-slider-nav]');

  sliderContainer = document.querySelector('[gallery-slider-container="wrapAround"]');

  galleryImages.forEach((galleryImage, index) => {
    // set current index of Slider
    if (galleryImage.getAttribute('data-flickity-target-id') == clickedElementId) {
      initialIndex = index;
    }

    if (!isFlickity) {
      let liNode = document.createElement('li');
      let navItem = document.createTextNode(index + 1);
      liNode.appendChild(navItem)
      // create custom nav
      navcontainer.appendChild(liNode);
    }

  });

  // initialise Flickity slider
  if (!isFlickity) {

    slider = new Flickity(sliderContainer, {
      // options
      initialIndex: initialIndex,
      cellAlign: 'center',
      imagesLoaded: true,
      lazyLoad: 2,
      prevNextButtons: false,
      pageDots: false
    });

    // detect slide change and update nav accordingly
    slider.on( 'select', function( index ) {
      setNavState(index);
    });

    // resume focus on gallery
    sliderContainer.focus();

    isFlickity = true

    // inititalise Flickity nav
    navWrapper.addEventListener('click', function() {

      if (isDescendant(event.target, 'gallery-nav')) {

        let index = event.target.innerHTML - 1
        initialIndex = index

        // set slider to correct slide
        slider.select(index);

        // set correct nav active on click
        setNavState(initialIndex);

      }

      //set Focus on slider
      sliderContainer.focus();
    })

    // set correct nav active state on modal open
    setNavState(initialIndex);

  } else {

    // set slider to correct slide
    slider.select(initialIndex, false, true);
    // detect slide change and update nav accordingly
    slider.on( 'select', function( index ) {
      setNavState(index);
    });
    //set Focus on slider
    sliderContainer.focus();

    // set correct nav active state on subsequent modal opens
    setNavState(initialIndex);

  }

  function setNavState(index){

    let navcontainerListEls = document.querySelectorAll('[gallery-slider-nav-count] li');

    navcontainerListEls.forEach(el => {
      // console.log('initialIndex', initialIndex);
      if (el.innerHTML == (index + 1)) {
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    })

  }

  // setFillGapMethod('max-width'); // String: 'padding', 'margin', 'width', 'max-width', 'none')


}

const destroySlider = () => {

  if ( isFlickity ) {
    // destroy slider
    slider.destroy();
  }

  isFlickity = false

}

const setModal = () => {

  galleryImageLinks = document.querySelectorAll('[data-flickity-id]');
  gallery = document.querySelector('[data-gallery-overlay]');

  // if no gallery on page, don't execute
  if (!gallery) return;

  // add event listener to each gallery thumbnail
  if (galleryImageLinks.length) {
    galleryImageLinks.forEach(galleryImageLink => {
      galleryImageLink.addEventListener("click", setActiveState);
    });
  }

  // add event listener to exit modal
  gallery.addEventListener("click", removeActiveState);

  // listen for escapeKey state
  document.addEventListener('keydown', function() {

    // if esc key pressed remove state
    if (event && event.key === 'Escape') {
     // if esc key was not pressed in combination with ctrl or alt or shift
        const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
        if (isNotCombinedKey) {
          // escape key was pressed with out any group keys
          
          // removeActiveState for modal;
          document.querySelector('[gallery-slider-nav-close-button]').click();
        }
        // console.log('esc key pressed');
    }

  }, false);


  trapModalFocus();    

}

const destroyModal = () => {

  destroySlider();

  // galleryImageLinks = document.querySelectorAll('[data-flickity-id]');
  // gallery = document.querySelector('[data-gallery-overlay]');

  // if (galleryImageLinks.length) {
  //   galleryImageLinks.forEach(galleryImageLink => {
  //     galleryImageLink.removeEventListener("click", setActiveState);
  //   });
  // }

  // gallery.removeEventListener("click", removeActiveState);

}

function removeActiveState(){

  let closeButton = document.querySelector('[gallery-slider-nav-close-button]');

  if (event.target != closeButton) return;

  //remove active state
  gallery.dataset.galleryOverlay = '';
  constants.body.classList.remove('gallery-active');

  // get the element that should scroll when page scrolling is disabled
  const $scrollableElement = gallery.querySelector('[data-scrollable]');
  // also, pass the element to the argument and enable scrolling on the page
  enablePageScroll($scrollableElement);


}


function setActiveState(){

  console.log('setActiveState',event.target);

  let clickedElement = event.target
  let clickedElementId = event.target.getAttribute('data-flickity-id');
  let isDragging = document.body.classList.contains('js-isDragging');

  if (isDragging) return;

  setSlider(clickedElementId);

  //add active state
  gallery.dataset.galleryOverlay = 'active';

  constants.body.classList.add('gallery-active'); 
  // // get the element that should scroll when page scrolling is disabled
  const $scrollableElement = gallery.querySelector('[data-scrollable]');
  // // pass the element to the argument and disable scrolling on the page
  disablePageScroll($scrollableElement);

}


function trapModalFocus() {

  // add all the elements inside modal which you want to make focusable
  const  focusableElements =
      '[gallery-slider-container]';
  const modal = gallery // select the modal by it's id

  const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
  const focusableContent = modal.querySelectorAll(focusableElements);
  const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal


  document.addEventListener('keydown', function(e) {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    // let isArrowsPressed = e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.keyCode === 37 || e.keyCode === 39;

    // if (isArrowsPressed) {
    //   console.log('arrow key pressed')
    //   lastFocusableElement.focus(); // add focus for the last focusable element
    //   e.preventDefault();
    // }

    if (!isTabPressed || !document.body.classList.contains('gallery-active')) {
      return;
    }

    if (e.shiftKey) { // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        e.preventDefault();
      }
    } else { // if tab key is pressed
      if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }

  });

  firstFocusableElement.focus();

}

export {setModal, destroyModal};